export const HttpMethods = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const APIContexts = {
  ASSET_HISTORY: 'AssetHistory',
  ASSET_VERSION: 'AssetVersion',
  CHANNEL: 'Channel',
  COMMERCIAL: 'Commercial',
  EXPORT: 'Export',
  INTERSTITIAL: 'Interstitial',
  PLAYLIST: 'Playlist',
  PROGRAMLIBRARY: 'ProgramLibrary',
  RIGHT: 'Right',
  SCHEDULE: 'Schedule',
  SEASON: 'Season',
  TITLE: 'Title',
  TITLE_EXCLUSION: 'TitleExclusion',
  TITLE_GROUP: 'TitleGroup',
  USER: 'User',
};
